import { DOM_IDS, MINIMALIST_CLASS, SELECTORS } from './constants.js'

export function resolveMountTarget({ isMinimalist }) {
  const selector = isMinimalist ? SELECTORS.MINIMALIST_MOUNT : SELECTORS.CONTENT_BODY
  return document.querySelector(selector)
}

export function applyMinimalistLayout(mountTarget) {
  if (!mountTarget) return
  mountTarget.classList.add(MINIMALIST_CLASS)
  const contentContainer = document.getElementById(DOM_IDS.CONTENT_CONTAINER)
  if (contentContainer) {
    contentContainer.style.minHeight = 'initial'
  }
}

export function createFooterContainer() {
  const container = document.createElement('div')
  container.id = DOM_IDS.FOOTER_CONTAINER
  return container
}
